import { render, staticRenderFns } from "./projectMovement.vue?vue&type=template&id=b6a7e34e&"
import script from "./projectMovement.vue?vue&type=script&lang=js&"
export * from "./projectMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports